/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <polygon
          points="12.63 0.02 14 1.32 7.04 8 0 1.31 1.36 0 7.03 5.39 12.63 0.02"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'DrawerCaretIcon';

export default Icon;
